import React, { useState, useEffect } from 'react';

const FORMAT_OPTIONS = [
  { key: 'excel', label: 'Excel', icon: 'fas fa-file-excel', color: '#1d6f42' },
  { key: 'csv', label: 'CSV', icon: 'fas fa-file-csv', color: '#e67e22' },
  { key: 'txt', label: 'TXT', icon: 'fas fa-file-alt', color: '#3498db' },
];

export default function ExcelColumnSelector({ columns, onExport, onClose }) {
  const [selected, setSelected] = useState({});
  const [allSelected, setAllSelected] = useState(false);
  const [includeHeader, setIncludeHeader] = useState(true);
  const [exportFormat, setExportFormat] = useState('excel');

  const allColumns = [{ id: 'id_bd', name: 'ID (id_bd)' }, ...columns];

  useEffect(() => {
    const initial = { id_bd: false };
    columns.forEach(col => { initial[col.id] = true; });
    setSelected(initial);
    setAllSelected(false);
  }, [columns]);

  const handleToggle = (colId) => {
    setSelected(prev => {
      const next = { ...prev, [colId]: !prev[colId] };
      setAllSelected(Object.values(next).every(Boolean));
      return next;
    });
  };

  const handleToggleAll = () => {
    const newVal = !allSelected;
    const next = {};
    allColumns.forEach(col => { next[col.id] = newVal; });
    setSelected(next);
    setAllSelected(newVal);
  };

  const selectedIds = Object.entries(selected).filter(([, v]) => v).map(([k]) => k);
  const selectedCount = selectedIds.length;
  const currentFormat = FORMAT_OPTIONS.find(f => f.key === exportFormat);

  return (
    <div className="cm-modal-overlay" onClick={onClose}>
      <div className="cm-modal-matrix" style={{ maxWidth: 520 }} onClick={e => e.stopPropagation()}>
        <div className="cm-modal-matrix__header">
          <span className="cm-modal-matrix__title">
            <i className="fas fa-download" style={{ marginRight: 8 }} />
            Exportar datos
          </span>
          <button className="cm-modal-richtext__close" onClick={onClose}>
            <i className="fas fa-times" />
          </button>
        </div>

        <div className="cm-modal-matrix__body" style={{ padding: 16 }}>
          {/* Format selector */}
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontWeight: 600, fontSize: 13, marginBottom: 6, display: 'block' }}>Formato de archivo</label>
            <div style={{ display: 'flex', gap: 8 }}>
              {FORMAT_OPTIONS.map(fmt => (
                <button
                  key={fmt.key}
                  onClick={() => setExportFormat(fmt.key)}
                  style={{
                    flex: 1,
                    padding: '8px 12px',
                    border: exportFormat === fmt.key ? `2px solid ${fmt.color}` : '2px solid #e0e0e0',
                    borderRadius: 6,
                    background: exportFormat === fmt.key ? `${fmt.color}10` : '#fff',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 6,
                    fontSize: 13,
                    fontWeight: exportFormat === fmt.key ? 600 : 400,
                    color: exportFormat === fmt.key ? fmt.color : '#666',
                    transition: 'all 0.15s'
                  }}
                >
                  <i className={fmt.icon} />
                  {fmt.label}
                </button>
              ))}
            </div>
          </div>

          {/* Include header toggle */}
          <div style={{ marginBottom: 14, padding: '8px 10px', background: '#f8f9fa', borderRadius: 6 }}>
            <label style={{ fontWeight: 500, fontSize: 13, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, margin: 0 }}>
              <input
                type="checkbox"
                checked={includeHeader}
                onChange={() => setIncludeHeader(!includeHeader)}
                style={{ width: 16, height: 16 }}
              />
              Incluir encabezado (nombres de columnas)
            </label>
          </div>

          {/* Column selector */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <label style={{ fontWeight: 600, fontSize: 13, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}>
              <input
                type="checkbox"
                checked={allSelected}
                onChange={handleToggleAll}
                style={{ width: 16, height: 16 }}
              />
              Seleccionar todas ({selectedCount}/{allColumns.length})
            </label>
          </div>

          <div style={{ maxHeight: 300, overflowY: 'auto', border: '1px solid #e9ecef', borderRadius: 6, padding: 4 }}>
            {allColumns.map(col => (
              <label
                key={col.id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  padding: '5px 10px',
                  cursor: 'pointer',
                  borderRadius: 4,
                  fontSize: 13,
                  backgroundColor: selected[col.id] ? '#f0f7ff' : 'transparent',
                  transition: 'background 0.15s'
                }}
              >
                <input
                  type="checkbox"
                  checked={!!selected[col.id]}
                  onChange={() => handleToggle(col.id)}
                  style={{ width: 15, height: 15 }}
                />
                <span>{col.name}</span>
              </label>
            ))}
          </div>
        </div>

        <div style={{ padding: '12px 16px', borderTop: '1px solid #e9ecef', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button className="cm-btn cm-btn--sm" onClick={onClose}>
            Cancelar
          </button>
          <button
            className="cm-btn cm-btn--sm cm-btn--primary"
            onClick={() => onExport({ columnIds: selectedIds, format: exportFormat, includeHeader })}
            disabled={selectedCount === 0}
            style={{ backgroundColor: currentFormat.color, borderColor: currentFormat.color }}
          >
            <i className={currentFormat.icon} style={{ marginRight: 4 }} />
            Descargar {currentFormat.label} ({selectedCount} col.)
          </button>
        </div>
      </div>
    </div>
  );
}
